import React, { useEffect } from 'react';
import { PageFooter, PageHeader } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { useAlliedBrokerPageStore } from 'store/pages/enrollment/broker/broker-allied/pageStore';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';
import { TinAndGaForm } from './TinAndGaForm';
import { SelectAgentForm } from './SelectAgentForm';
import { AgentDetailsForm } from './AgentDetailsForm';

const PageContent: React.FC = observer(() => {
  const pageStore = useAlliedBrokerPageStore();

  useEffect(() => {
    void pageStore.getInitialData();
  }, []);

  return (
    <>
      <PageHeader
        title={CARD_DATA.ALLIED_BROKER.title}
        subtitle={CARD_DATA.ALLIED_BROKER.text}
        onBackButtonClick={pageStore.onBackRedirect}
      />
      <TinAndGaForm />
      <SelectAgentForm />
      <AgentDetailsForm />
      <PageFooter
        onBack={pageStore.onBackRedirect}
        onComplete={pageStore.onComplete}
        disableCompleteButton={!pageStore.canCompleteStep}
      />
    </>
  );
});

export default PageContent;
